import { ColumnConfig, TabType } from "./types";

const HIDDEN_KEYS = ["alertLevel", "lastReportDate", "services", "planType","cancelledDate"];

export const getColumnConfigByTab = (tab: TabType): ColumnConfig[] => {
  const baseColumns: ColumnConfig[] = [
    {
      key: "name",
      label: "Name",
      field: "FirstName",
      type: "name",
      sortable: true,
      wrap: false,
    },
  ];

  const columnSets: Record<TabType, ColumnConfig[]> = {
    Enrolled: [
      { key: "alertLevel", field: "TaxRiskReportRiskLevel", label: "Alerts", type: "alertLevel", sortable: true, align: "left" },
      { key: "lastReportDate", field: "LastTaxRiskReportDate", label: "Last Report Date", type: "date", sortable: true },
      { key: "enrolledDate", field: "EnrolledAt", label: "Enrolled Date", type: "date", sortable: true },
      { key: "services", field: "ActiveServices", label: "Active Service(s)", type: "services", sortable: true, align: "left" },
      { key: "planType", field: "PlanType", label: "Plan Type", type: "plan", sortable: true, align: "left" },
    ],
    Pending: [
      { key: "referredDate", field: "ReferredAt", label: "Referred Date", type: "date", sortable: true },
    ],
    Cancelled: [
      { key: "cancelledDate", field: "CanceledAt", label: "Cancellation Date", type: "date", sortable: true },
      { key: "lastReportDate", field: "LastTaxRiskReportDate", label: "Last Report Date", type: "date", sortable: true },
      { key: "enrolledDate", field: "EnrolledAt", label: "Enrolled Date", type: "date", sortable: true },
      { key: "planType", field: "PlanType", label: "Plan Type", type: "plan", sortable: true, align: "left" },
    ],
    "Payment Issue": [
      { key: "lastFailedPaymentValue", field: "LastPaymentFailureAmount", label: "Last Failed Pmt Value", type: "number", sortable: true },
      { key: "lastSuccessfulPaymentDate", field: "LastPaymentSuccessDate", label: "Last Pmt Success Date", type: "date", sortable: true },
      { key: "lastReportDate", field: "LastTaxRiskReportDate", label: "Last Report Date", type: "date", sortable: true },
      { key: "enrolledDate", field: "EnrolledAt", label: "Enrolled Date", type: "date", sortable: true },
      { key: "services", field: "ActiveServices", label: "Active Service(s)", type: "services", sortable: true, align: "left" },
      { key: "planType", field: "PlanType", label: "Plan Type", type: "plan", sortable: true, align: "left" },
    ],
    All: [
      { key: "alertLevel", field: "TaxRiskReportRiskLevel", label: "Alerts", type: "alertLevel", sortable: true, align: "left" },
      { key: "lastReportDate", field: "LastTaxRiskReportDate", label: "Last Report Date", type: "date", sortable: true },
      { key: "enrolledDate", field: "EnrolledAt", label: "Enrolled Date", type: "date", sortable: true },
      { key: "referredDate", field: "ReferredAt", label: "Referred Date", type: "date", sortable: true },
      { key: "services", field: "ActiveServices", label: "Active Service(s)", type: "services", sortable: true, align: "left" },
      { key: "planType", field: "PlanType", label: "Plan Type", type: "plan", sortable: true, align: "left" },
      { key: "status", field: "LeadStatus", label: "Status", type: "status", sortable: true },
    ],
    Alerts: [
      { key: "alertLevel", field: "TaxRiskReportRiskLevel", label: "Alerts", type: "alertLevel", sortable: true, align: "left" },
      { key: "lastReportDate", field: "LastTaxRiskReportDate", label: "Last Report Date", type: "date", sortable: true },
      { key: "enrolledDate", field: "EnrolledAt", label: "Enrolled Date", type: "date", sortable: true },
      { key: "referredDate", field: "ReferredAt", label: "Referred Date", type: "date", sortable: true },
      { key: "services", field: "ActiveServices", label: "Active Service(s)", type: "services", sortable: true, align: "left" },
      { key: "planType", field: "PlanType", label: "Plan Type", type: "plan", sortable: true, align: "left" },
      { key: "status", field: "LeadStatus", label: "Status", type: "status", sortable: true },
    ],
  };

  const tabColumns = columnSets[tab] || [];

  return [...baseColumns, ...tabColumns];
};
